import { render, staticRenderFns } from "./DetailsSummary.vue?vue&type=template&id=f8493090"
import script from "./DetailsSummary.vue?vue&type=script&lang=js"
export * from "./DetailsSummary.vue?vue&type=script&lang=js"
import style0 from "./DetailsSummary.vue?vue&type=style&index=0&id=f8493090&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports